// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__hKXf-","smaller":"Spinner_smaller__smq3K","progress":"Spinner_progress__YdBTY","dot-progress":"Spinner_dot-progress__nLnoC"};